@if (signingIn) {
<div class="auth-status-page">
  <div class="auth-status-brand" aria-label="Roots by EarthScout">
    <img src="assets/images/earthscoutIcon.PNG" alt="" width="40" height="40" />
    <span>ROOTS</span>
  </div>
  <section class="auth-status-card" role="status" aria-live="polite" aria-busy="true">
    <div class="auth-status-indicator" aria-hidden="true">
      <span class="auth-status-spinner"></span>
      <mat-icon>lock_outline</mat-icon>
    </div>
    <div class="auth-status-eyebrow">Welcome to Roots</div>
    <h1>Signing you in…</h1>
    <p>We’re getting your workspace ready.<br />You’ll be redirected automatically.</p>
    <div class="auth-status-progress" aria-hidden="true"><span></span></div>
  </section>
  <p class="auth-status-footer">An EarthScout Smart platform</p>
</div>
} @else {
<div class="auth-status-page login-page">
  <div class="auth-status-brand" aria-label="Roots by EarthScout">
    <img src="assets/images/earthscoutIcon.PNG" alt="" width="40" height="40" />
    <span>ROOTS</span>
  </div>
  <section class="auth-status-card login-card">
    <div class="auth-status-indicator" aria-hidden="true"><mat-icon>login</mat-icon></div>
    <div class="auth-status-eyebrow">EarthScout workspace</div>
    <h1>Welcome to Roots</h1>
    <p>Sign in to manage your customers, assets, and scouts.</p>
    @if (userName) {
      <div class="login-account"><mat-icon aria-hidden="true">account_circle</mat-icon><span>{{ userName }}</span></div>
    }
    @if (error && !isLoading) {
      <div class="login-error" role="alert"><mat-icon aria-hidden="true">error_outline</mat-icon><span>{{ error }}</span></div>
    }
    <button mat-flat-button type="button" class="login-primary" (click)="azureLogin()" [disabled]="isLoading">
      <mat-icon>login</mat-icon>{{ isLoading ? 'Signing in…' : 'Sign in with Microsoft' }}
    </button>
    <div class="login-cache">
      <div class="login-cache-heading"><mat-icon aria-hidden="true">refresh</mat-icon><h2>Having trouble signing in?</h2></div>
      <p>Clear your saved session, then sign in again.</p>
      <button mat-stroked-button type="button" class="login-secondary" (click)="logout()" [disabled]="isLoading">Clear cache</button>
    </div>
    @if (userName) {
      <p class="login-help">Need help with your account? <button mat-button type="button" (click)="sendNotification()">Contact an admin</button></p>
    }
  </section>
  <p class="auth-status-footer">An EarthScout Smart platform · v{{ version }}</p>
</div>
}
